export default {
  computed: {
    donutChartOptions() {
      if (!this.showChart) return {}
      const options = {
        width: '100px',
        title: {
          text: this.chartData.name,
          textStyle: {
            color: this.curTheme[this.theme].fontColor,
            fontSize: 12
          }
        },
        grid: {
          show: false,
          left: 10,
          top: 0,
          right: 10,
          bottom: 0
        },
        tooltip: {
          trigger: 'item',
          padding: 0,
          backgroundColor: '#fff',
          textStyle: {
            color: '#000'
          },
          position: function(point) {
            return [point[0] + 10, point[1] + 5]
          }
        },
        cursor: 'default',
        series: [
          {
            type: 'pie',
            radius: ['21px', '50px'],
            center: ['50%', '50%']
          }
        ]
      }
      options.series[0].data = this.chartData.map((item, index) => {
        const percent = parseFloat(item.percent)
        const legendString = `${percent.toFixed(0)}%`
        const isShowLabel = percent.toFixed(0) >= 10
        const valObject = {
          name: legendString,
          hoverAnimation: false,
          avoidLabelOverlap: false,
          value: percent,
          itemStyle: {
            normal: {
              color: this.flowList[this.upType][item.id],
              borderWidth: 1,
              borderColor: this.curTheme[this.theme].bgColor
            },
            emphasis: {
              color: this.flowList[this.upType][item.id]
            }
          },
          label: {
            normal: {
              show: isShowLabel,
              position: 'inside',
              textStyle: {
                fontSize: '11',
                color: this.curTheme[this.theme].donutFontColor,
                fontWeight: 'bolder'
              }
            },
            emphasis: {
              show: true
            }
          },
          tooltip: {
            formatter: function() {
              const { name, count, percent } = item
              return `<div class="donut-tooltip">${name}:${count}(${percent}%)</div>`
            }
          }
        }
        return valObject
      })
      return options
    }
  }
}
